import { lazy } from 'react';

import { AuthLayout } from './components/auth-layout';

const LoginPage = lazy(() => import('./pages/login'));
const ForgotPasswordPage = lazy(() => import('./pages/forgot-password'));
const ResetPasswordPage = lazy(() => import('./pages/reset-password'));
const VerifyIdentityPage = lazy(() => import('./pages/verify-identity'));
const SetPasswordPage = lazy(() => import('./pages/set-password'));

// One pathless layout route: the artwork column stays mounted while the user
// moves between these screens, only the form column changes.
export const authRoutes = [
  {
    Component: AuthLayout,
    children: [
      {
        path: '/',
        Component: LoginPage,
      },
      {
        path: '/forgot-password',
        Component: ForgotPasswordPage,
      },
      {
        // Keep in sync with TWO_FACTOR_PATH (auth.hooks) and the auth pages in
        // setup-axios, where a 401 for a wrong code must not sign the user out.
        path: '/verify-identity',
        Component: VerifyIdentityPage,
      },
      {
        // Keep in sync with SET_PASSWORD_PATH (auth.hooks) and the auth pages in
        // setup-axios: an expired token answers 401 here too.
        path: '/set-password',
        Component: SetPasswordPage,
      },
      {
        path: '/reset-password/:email/:token',
        Component: ResetPasswordPage,
      },
    ],
  },
];
